<template>
  <svg class="conclusion-foot-vect" :viewBox="'0 0 ' + winW + ' ' + scaledHeight" xmlns="http://www.w3.org/2000/svg"
       :width="winW + 'px'" :height="scaledHeight + 'px'">
    <defs>
      <linearGradient x1="62.0642791%" y1="60.8855973%" x2="95.2295775%" y2="97.1838781%" id="conclusion-a" gradientTransform="rotate(170 0.5 0.5)">
        <stop :stop-color="mainColor" offset="0%"></stop>
        <stop :stop-color="accent" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="111.464583%" y1="10.1152036%" x2="0%" y2="114.213004%" id="conclusion-b" gradientTransform="rotate(90 0.5 0.5)">
        <stop :stop-color="mainColor" offset="0%"></stop>
        <stop :stop-color="accent" offset="100%"></stop>
      </linearGradient>
    </defs>

    <polygon fill="url(#conclusion-a)" :points="winW + ' ' + scaledHeight + ' 0 ' + scaledHeight + ' 0 20 ' + winW + ' 100'"/>
    <polygon fill="url(#conclusion-b)" :points="'0 ' + scaledHeight + ' 0 80 ' + winW + ' 0 ' + winW + ' ' + scaledHeight"/>
  </svg>
</template>

<script>
  import StateMixin from '@/components/report/mixins/StateMixin'

  export default {
    name: 'ConclusionVect',
    mixins: [ StateMixin ],
    computed: {
      scaledHeight () {
        return 1404 * (this.winW / 375)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/report/footers/ConclusionVect.vue